export const NAME = 'virtualCards'
export const VCN_GET = 'employeeBenefitsVcnGet'
export const VCN_POST = 'employeeBenefitsVcnPost'

export enum VirtualCardType {
  WEX = 'WEX',
  MARQETA = 'MARQETA',
}

/** WEX VCN lifecycle actions (matches VCN action form option ids). */
export enum WexVirtualCardLifecycleAction {
  SUSPEND = 'suspend',
  TERMINATE = 'terminate',
  REACTIVATE = 'reactivate',
}
